export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://junk-in-da-truck-production.up.railway.app';
export const API = `${BACKEND_URL}/api`;
